import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { CONTENT } from "@/content";
import { getAnonId, publicGet, useApi } from "@/lib/api";

const SettingsContext = createContext(null);

const merge = (stored) => Object.fromEntries(
  Object.entries(CONTENT.defaults).map(([k, defs]) => [
    k, Object.fromEntries(Object.entries(defs).map(([f, d]) => [f, stored?.[k]?.[f] || d])),
  ]),
);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(merge({}));
  const reload = useCallback(() => publicGet("/settings").then((s) => setSettings(merge(s))).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return <SettingsContext.Provider value={{ settings, reload }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);

// Attaches shares made in this browser to the account after login.
export const AuthSync = () => {
  const { isSignedIn } = useAuth();
  const api = useApi();
  useEffect(() => {
    if (isSignedIn) api("post", "/shares/claim", { anon_id: getAnonId() }).catch(() => {});
  }, [isSignedIn, api]);
  return null;
};
